import { render, staticRenderFns } from "./impact-amounts.vue?vue&type=template&id=ef18d78e&scoped=true&"
import script from "./impact-amounts.vue?vue&type=script&lang=js&"
export * from "./impact-amounts.vue?vue&type=script&lang=js&"
import style0 from "./impact-amounts.vue?vue&type=style&index=0&id=ef18d78e&prod&lang=scss&"
import style1 from "./impact-amounts.vue?vue&type=style&index=1&id=ef18d78e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef18d78e",
  null
  
)

export default component.exports